export const LS_COMPLIANCE_SUBMIT_KEY = 'compliance-submit-key';
